<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="4">
                  <BaseInput :options="titleInput.options" :data="titleInput.data"/>
                </CCol>
                <CCol xs="12" sm="6" md="6" lg="6" xl="4">
                  <BaseSelect :options="departmentsInput.options" :data="departmentsInput.data"
                              ref="departmentsInput"></BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" lg="6" xl="4">
                  <BaseSelect :options="levelSelect.options" :data="levelSelect.data" ref="levelSelect"></BaseSelect>
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data"
                                v-model="descriptionInput.data.model"/>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData(false)">
                  <i class="fa fa-plus"></i> Lưu lại
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "./BaseSelect2";
import BaseInput from "./BaseInput";
import BaseLoading from "./BaseFormLoading";
import BaseTextArea from "./BaseTextArea.vue";

export default {
  name: "BaseAudioAddFile",
  components: {BaseSelect, BaseInput, BaseLoading, BaseTextArea},
  props: ["file", "duration", "sourceType"],
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      fileName: 'Chọn tệp',
      titleInput: {
        options: {
          label: "Tiêu đề bản tin <span class='required'>*</span>",
          placeholder: "Tiêu đề bản tin",
          maxlength: 200
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tiêu đề bản tin không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      sourceTypeSelect: {
        data: {
          name: "sourceType",
          model: this.sourceType,
        }
      },
      selectFile: {
        data: {
          name: "file",
          model: this.file,
        }
      },
      durationFile: {
        data: {
          name: "duration",
          model: this.duration,
        }
      },
      descriptionInput: {
        options: {
          label: "Mô tả bản tin",
          placeholder: "Mô tả bản tin",
          maxlength: 2000,
          rows: 5
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          }
        }
      },
      departmentsInput: {
        options: {
          filter: true,
          label: "Lĩnh vực <span class='required'>*</span>",
          selectAllText: "Chọn lĩnh vực",
        },
        data: {
          name: "fileTypeId",
          items: [],
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.departmentsInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Lĩnh vực bản tin phải được chọn";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      levelSelect: {
        options: {
          filter: false,
          label: 'Mức độ ưu tiên',
        },
        data: {
          name: "level",
          items: [
            {key: "0", value: "Bình thường"},
            {key: "1", value: "Ưu tiên"},
            {key: "2", value: "Khẩn cấp"},
          ],
          model: "0",
          updateCallback: function () {
            that.submitData();
          },
        }
      },
      userName: {
        data: {
          name: "userName",
          model: localStorage.getItem("userName")
        }
      },
    }
  },
  methods: {
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.titleInput.data.validator.valid();
      isValid &= this.departmentsInput.data.validator.valid();
      if (!isValid) {
        return;
      }
      that.$emit("loading", true);
      this.$helper.loadDataSource({
        url: "/audio-file/addFile",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Biên tập bản tin thành công"});
            that.$router.push('/files-device-management/managed-files.html')
          }
          that.$emit("loading", false);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.$emit("loading", false);
        }
      });
    },
    resetData() {
      let that = this;
      that.$helper.setupDataResponse(that.$data, {});
      that.levelSelect.data.model = "0";
    },
    loadDataDepartment: function () {
      let that = this;
      this.$helper.loadDataSource({
        url: "/common/listField",
        successCallback: function (response) {
          that.departmentsInput.data.items = response.data.data;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  computed: {},
  created() {
  },
  mounted() {
    this.loadDataDepartment();
  },
  watch: {
    'departmentsInput.data.model': function () {
      this.departmentsInput.data.validator.valid();
    },
    file(value) {
      this.selectFile.data.model = value;
    },
    duration(value) {
      this.durationFile.data.model = value;
    }
  }
};
</script>
